__turbopack_context__.v({
  "columnWithShadow": "features-module-scss-module__4o4g8G__columnWithShadow",
  "feature": "features-module-scss-module__4o4g8G__feature",
  "featureColumnHeader": "features-module-scss-module__4o4g8G__featureColumnHeader",
  "featureColumnIcon": "features-module-scss-module__4o4g8G__featureColumnIcon",
  "featureColumnTitle": "features-module-scss-module__4o4g8G__featureColumnTitle",
  "featureIcon": "features-module-scss-module__4o4g8G__featureIcon",
  "featureTitle": "features-module-scss-module__4o4g8G__featureTitle",
  "features": "features-module-scss-module__4o4g8G__features",
  "featuresColumn": "features-module-scss-module__4o4g8G__featuresColumn",
  "featuresColumnWrp": "features-module-scss-module__4o4g8G__featuresColumnWrp",
  "featuresCta": "features-module-scss-module__4o4g8G__featuresCta",
  "featuresCtaBtn": "features-module-scss-module__4o4g8G__featuresCtaBtn",
  "featuresRow": "features-module-scss-module__4o4g8G__featuresRow",
  "featuresWrp": "features-module-scss-module__4o4g8G__featuresWrp",
});
